<script>
import { service, status } from "../../../config/deposit-request"

export default {
  props: {
    filters: {
      default: null
    }
  },
  computed: {
    statusOptions() {
      return Object.values(status).map((s) => ({value: s, label: s.toUpperCase() }))
    },
    serviceOptions() {
      return Object.values(service).map((s) => ({value: s, label: s.toUpperCase() }))
    },
    filteredRanges: {
      get() {
        return this.queries.date.map((o) => this.moment(o, 'YYYY-MM-DD HH:mm:ss'))
      },
      set(val) {
        this.queries.date = val.map((moment) => moment.format('YYYY-MM-DD HH:mm:ss'))
      }
    },
  },
  data: () => ({
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
    queries: {
      page: 1,
      q: '',
      types: [],
      statuses: [],
      date: [],
      clients: [],
      amount: null
    }
  }),
  methods: {
    autocomplete(v, iteratee) {
      if (v.length === 0) {
        this.queries[iteratee] = []
      } else {
        this.queries[iteratee] = _.map(v, (o) => o.id)
      }
    },
    reset() {
      this.queries = {
        page: 1,
        q: '',
        types: [],
        statuses: [],
        date: [],
        clients: [],
        amount: null
      }

      this.submit()
    },
    submit() {
      this.$emit("filtered", this.queries)
    },
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler: function(v) {
        if (v instanceof Object)
          Object.assign(this.queries, v)
      }
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-form-model :model="queries" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="Keyword">
      <a-input placeholder="Keyword.." v-model="queries.q">
        <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)"/>
      </a-input>
      </a-form-model-item>

      <a-form-model-item label="Date/Time">
        <a-range-picker :showTime="{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]}" :ranges="dateRanges" format="YYYY-MM-DD HH:mm:ss" v-model="filteredRanges" style="width: 100%"/>
      </a-form-model-item>

      <a-form-model-item label="Amount">
        <a-tooltip :trigger="['focus']" placement="topLeft">
          <span slot="title" v-if="queries.amount"> {{ currency(queries.amount) }}</span>
          <template slot="title" v-else>
            Input a number
          </template>

          <a-input placeholder="Amount" v-model="queries.amount">
            <a-icon slot="prefix" type="dollar" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-tooltip>
      </a-form-model-item>

      <a-form-model-item label="Client">
        <client-autocomplete style="width: 100%" @change="(item) => autocomplete(item, 'clients') "/>
      </a-form-model-item>

      <a-form-model-item label="Status">
        <a-checkbox-group v-model="queries.statuses" :options="statusOptions" />
      </a-form-model-item>

      <a-form-model-item label="Type">
        <a-checkbox-group v-model="queries.types" :options="serviceOptions" />
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 16, offset: 4}">
        <a-space>
          <a-button type="primary" @click="submit" icon="filter">Filter</a-button>
          <a-button class="ml-2" icon="reload" @click="reset">Reset</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>
